import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private _snackBar: MatSnackBar) {}
  openSnackBar(
    message: string,
    action: string = 'close',
    duration: number = 2000,
    verticalPosition: 'top' | 'bottom' = 'top'
  ) {
    this._snackBar.open(message, action, {
      duration: duration,
      verticalPosition: verticalPosition,
    });
  }
}
